export const EXPERIMENTS = {
  USE_FIELDS_V2: 'specs.forms.UseFieldsV2',
  ENABLE_SUBMIT_LIMITS_SETTINGS: 'specs.forms.EnableSubmitLimitsSettings',
  APPOINTMENT_FIELD_V11: 'specs.forms.EnableAppointmentFieldV11',
  ENABLE_RICH_TEXT_SETTINGS: 'specs.forms.EnableRichTextSettings',
  ENABLE_READ_ONLY_SETTING: 'specs.forms.EnableReadOnlySetting',
  ENABLE_DEFAULT_VALUE_SETTING: 'specs.forms.EnableDefaultValueSetting',
  SERVICE_DROPDOWN_OTHER_OPTIONS: 'specs.forms.ServiceDropdownOtherOptions',
  ENABLE_FLOATING_ACTION_TOOLBAR: 'specs.forms.EnableFieldActionToolbar',
  ENABLE_FIELD_ACTION_TOOLBAR_WIXEL: 'specs.forms.EnableFieldActionToolbarWixel',
  REMOVE_FALSY_VALUES: 'specs.forms.RemoveFalsyValues',
  ENABLE_SCHEDULING: 'specs.forms.changeAppointmentToScheduling',
  BIF_ON_MEETINGS: 'specs.bookings.BIFonMeetings',
  INFORM_MEETINGS_USERS: 'specs.bookings.InformMeetingsUsers',
  BIF_ON_MEETINGS_PHASE_3: 'specs.bookings.InstallMeetingsForBIF'
};
//# sourceMappingURL=experiments.js.map